import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { POSTS } from '../constants'

const deletePost = async (id: number) => {
  await fetchAPI({
    path: `/posts/${id}`,
    method: 'delete',
  })
}

export const useDeletePost = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deletePost, {
    async onSuccess() {
      await queryClient.refetchQueries([POSTS])

      toast({
        description: t('views.admin.posts.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
